import { loginUser } from '../../../API/Auth';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import jwt_decode from 'jwt-decode';
import authActions from './constants';
import { store } from '../../../store';

export function startLogin() {
    return {
        type: authActions.LOGIN_START
    };
}
export function LoginSuccess(user) {
    console.log('success login user', user);
    return {
        type: authActions.LOGIN_SUCCESS,

        user
    };
}
export function LoginFailed(errorMessage) {
    return {
        type: authActions.LOGIN_FAILURE,
        error: errorMessage
    };
}

export const login = (
    values,
    setLoading,
    navigate,
    toast,
    handleLoginError
) => {
    console.log('calling api');
    console.log('values', values);
    return async () => {
        try {
            store.dispatch(startLogin());
            const response = await loginUser(values);
            setLoading(false);
            if (!response.data.success) {
                toast.error(response.data.error);
                handleLoginError(); // Call the new error handler
                return;
            }
            localStorage.setItem('token', response.data.data.token);
            const user =
                response.data.data.token &&
                jwt_decode(response.data.data.token);
            store.dispatch(LoginSuccess(user));
            navigate('/dashboard');
        } catch (error) {
            console.log('error', error);
            setLoading(false);

            // Safely extract the error message from various possible backend formats
            const errMsg =
                error?.response?.data?.errors?.[0]?.msg ||
                error?.response?.data?.message ||
                error?.response?.data?.error ||
                error?.message ||
                'Login failed';

            toast.error(errMsg);
            if (typeof handleLoginError === 'function') {
                handleLoginError(); // Call the new error handler
            }
        }

        // console.log(response);
        // toast.error(response.data.message);
        // store.dispatch(LoginFailed(response.data.message));

        //   localStorage.setItem("token", response.data.data.token);
        <ToastContainer />;
    };
};
